import React, { useEffect } from 'react';
import { connect } from 'react-redux';
//Actions
import { logGet } from '../../actions/log';
//Components
import LogDate from './LogDate';
import Loader from 'locki-dashboard-navigation/dist/loader';
import Table from 'locki-dashboard-navigation/dist/table';
//Material-ui
import Paper from '@material-ui/core/Paper';

function PhonebotLog({ clan, log, logGet }) {
  useEffect(() => {
    logGet('phonebot', clan);
  }, []);

  const data = log ? log.phonebot : undefined;

  const columns = [
    {
      id: 'date',
      align: 'left',
      padding: 'none',
      label: 'Fecha',
      component: LogDate,
    },
    { id: 'userName', align: 'right', label: 'Usuario' },
    { id: 'clanAddress', align: 'right', label: 'Domicilio' },
    { id: 'clanName', align: 'right', label: 'Familia' },
    { id: 'gateName', align: 'right', padding: 'none', label: 'Puerta' },
  ];

  const table = (
    <Paper className="general-paper">
      <Table data={data} order="desc" columns={columns} title="Registro" />
    </Paper>
  );
  return data === undefined ? <Loader /> : table;
}

const mapStateToProps = (state) => ({
  log: state.log,
});

const mapDispatchToProps = (dispatch) => ({
  logGet: (method, clan) => dispatch(logGet(method, clan)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PhonebotLog);
